import userProfileSettings from "./userProfileSettings";
import updateUserProfileSettings from "./updateUserProfileSettings";
const Settings = {
  userProfileSettings,
  updateUserProfileSettings,
};

export default Settings;
